export default __webpack_public_path__ + "static/media/menu9_hl.b6f2d59e.png";